<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	let props: HTMLAttributes<SVGElement> = $props();
</script>

<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
	<path
		d="M4.872 2L3.528 6C4.648 6.096 5.32 6.896 5.32 8.016C5.32 9.232 4.456 10.064 3.144 10.064C1.8 10.064 1 9.2 1 7.92C1 7.504 1.128 6.96 1.384 6.416L3.336 2H4.872ZM10.248 2L8.904 6C10.024 6.096 10.696 6.896 10.696 8.016C10.696 9.232 9.832 10.064 8.52 10.064C7.176 10.064 6.376 9.2 6.376 7.92C6.376 7.504 6.504 6.96 6.76 6.416L8.712 2H10.248Z"
		fill="currentColor"
	/>
</svg>
